<template>
  <div
    v-if="formGroup"
    class="form-group"
    :style="{ marginBottom: formGroupMarginBottom ? '15px' : null }"
  >
    <label
      v-if="title"
      class="control-label"
      :style="{ width: labelWidth }"
    >{{ title }}</label>
    <!--
      Вызывается при изменении значения.

      @event input
      @property {String} value Значение.
    -->
    <select
      v-if="!loading"
      class="form-control"
      :class="{ 'text-bold': bold }"
      :style="{ width: selectWidth }"
      :disabled="disabled"
      @change="$emit('input', $event.target.value)"
    >
      <option
        v-for="(item, index) in options"
        :key="index"
        :value="Array.isArray(options) ? item : index"
        :selected="(Array.isArray(options) ? item : index) == value || (!value && firstOptionDisabled && Array.isArray(options) && index === 0) "
        :disabled="firstOptionDisabled && Array.isArray(options) && index === 0"
      >
        {{ item }}
      </option>
    </select>
    <c-spinner v-else />
  </div>
  <select
    v-else-if="!loading"
    class="form-control"
    :class="{ 'text-bold': bold }"
    :style="{ width: selectWidth }"
    :disabled="disabled"
    @change="$emit('input', $event.target.value)"
  >
    <option
      v-for="(item, index) in options"
      :key="index"
      :value="Array.isArray(options) ? item : index"
      :selected="(Array.isArray(options) ? item : index) == value"
      :disabled="firstOptionDisabled && Array.isArray(options) && index === 0"
    >
      {{ item }}
    </option>
  </select>
  <c-spinner v-else />
</template>

<script>
import CSpinner from './CSpinner'
/**
 * Select.
 */
export default {
  name: 'CSelect',
  components: { CSpinner },
  props: {
    /**
     * Текущее значение.
     *
     * @model
     */
    value: {
      validator (value) {
        return ['string', 'number'].includes(typeof value) || value === null
      },
      required: true
    },
    /**
     * Элементы (массив или объект).
     */
    options: {
      validator (options) {
        return typeof options === 'object'
      },
      required: true
    },
    /**
     * Возможно ли выбрать первый элемент.
     */
    firstOptionDisabled: {
      type: Boolean,
      default: false
    },
    /**
     * Возможно ли изменение значения.
     */
    disabled: {
      type: Boolean,
      default: false
    },
    /**
     * Обернуть ли select в div.form-group.
     */
    formGroup: {
      type: Boolean,
      default: false
    },
    /**
     * Отступ снизу от div.form-group.
     */
    formGroupMarginBottom: {
      type: Boolean,
      default: false
    },
    /**
     * Текст для лейбла.
     */
    title: {
      type: String,
      default: ''
    },
    /**
     * Статус загрузки.
     */
    loading: {
      type: Boolean,
      default: false
    },
    /**
     * Нужно ли выделить жирным текст значения.
     */
    bold: {
      type: Boolean,
      default: false
    },
    labelWidth: {
      type: String,
      default: null
    },
    selectWidth: {
      type: String,
      default: null
    }
  }
}
</script>
